<div class="row">
  <app-tabs-header
    [showPrefix]="true"
    [showSuffix]="true"
    [prefixTemplate]="logoTemplate"
    [suffixTemplate]="settingsTemplate"
    [upperTemplate]="datePickerTemplate"
    [tabs]="tabs"
    [presentation]="settings.presentation"
    (tabChange)="handleTabChange($event)"
    (subTabChange)="handleSubTabChange($event)"
  >
    <ng-template #logoTemplate>
      <app-logo [url]="cloud?.configuration?.logoUrl"></app-logo>
    </ng-template>
    <ng-template #settingsTemplate>
      <button mat-icon-button color="{{ settings?.presentation ? 'primary' : null }}" (click)="handlePresentationClick()">
        <mat-icon>slideshow</mat-icon>
      </button>
      <button mat-icon-button (click)="handleCloudConfigurationClick()">
        <mat-icon>settings</mat-icon>
      </button>
      <button mat-button [matMenuTriggerFor]="objectsMenu">
        <mat-icon>arrow_drop_down</mat-icon>
        <span>{{ object?.cloudId }}</span>
      </button>
      <mat-menu #objectsMenu="matMenu">
        <button *ngFor="let o of objects" mat-menu-item class="btn-select-object" (click)="handleObjectClick(o)">
          <mat-icon *ngIf="object?.cloudId === o.cloudId">check_box</mat-icon>
          <mat-icon *ngIf="object?.cloudId !== o.cloudId">check_box_outline_blank</mat-icon>
          <div class="title">
            <span>{{ o.cloudId }}</span>
            <mat-icon *ngIf="object?.cloudId !== o.cloudId" (click)="$event.stopPropagation(); handleObjectDeleteClick(o)">delete</mat-icon>
          </div>
        </button>
        <button mat-menu-item class="btn-add-object" (click)="handleAddObjectClick()">{{ "pages.landing.buttons.addObject" | translate }}</button>
      </mat-menu>
      <button mat-icon-button (click)="handleLogoutClick()">
        <mat-icon>logout</mat-icon>
      </button>
    </ng-template>
    <ng-template #datePickerTemplate>
      <button mat-icon-button class="btn-date-arrow" (click)="handleDatePickerStep(-1)">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <div class="current-date">{{ globalActions | activeAction | actionDateRange }}</div>
      <button mat-icon-button class="btn-date-arrow" (click)="handleDatePickerStep(1)">
        <mat-icon>chevron_right</mat-icon>
      </button>
      <ng-container *ngFor="let action of globalActions">
        <ng-container [ngTemplateOutlet]="action.template" [ngTemplateOutletContext]="{ data: action.data }"></ng-container>
      </ng-container>
      <button mat-stroked-button (click)="handleExportClick()">
        {{ "pages.landing.buttons.export" | translate }}
      </button>
    </ng-template>
  </app-tabs-header>
  <div class="charts">
    <div class="row align-items-start">
      <ng-container *ngIf="activeSubTab">
        <div class="col-lg-12" *ngIf="activeSubTab.stats && activeSubTab.stats.length > 0">
          <div class="row justify-content-center">
            <div class="col-lg-3" *ngFor="let stat of activeSubTab.stats">
              <app-stat-card [label]="stat.label" [value]="stat.value" [units]="stat.units"></app-stat-card>
            </div>
          </div>
        </div>
        <div [ngClass]="{ 'col-lg-6': activeTab.dashboard, 'col-lg-12': !activeTab.dashboard }" *ngFor="let graph of activeSubTab.flowGraphs">
          <app-flow-graph [dataLoaded]="graph.dataLoaded" [label]="graph.label" [data]="graph.data"></app-flow-graph>
        </div>
        <div [ngClass]="{ 'col-lg-6': activeTab.dashboard, 'col-lg-12': !activeTab.dashboard }" *ngFor="let chart of activeSubTab.charts">
          <app-chart [dataLoaded]="chart.dataLoaded" [label]="chart.label" [meterType]="chart.type" [data]="chart.data" [type]="chart.settings.type" [actions]="chart.actions">
          </app-chart>
        </div>
      </ng-container>
    </div>
  </div>
  <app-footer></app-footer>
</div>

<ng-template #globalScaleTemplate let-data="data">
  <button *ngIf="!data.active" mat-stroked-button (click)="handleGlobalScaleClick(data)">{{ data.label | translate }}</button>
  <button *ngIf="data.active" mat-flat-button color="primary" (click)="handleGlobalScaleClick(data)">{{ data.label | translate }}</button>
</ng-template>
<ng-template #globalRangeTemplate let-data="data">
  <button *ngIf="!data.active" mat-stroked-button (click)="handleGlobalRangeClick(data)">{{ data.label | translate }}</button>
  <button *ngIf="data.active" mat-flat-button color="primary" (click)="handleGlobalRangeClick(data)">{{ data.label | translate }}</button>
</ng-template>
<ng-template #chartExportTemplate let-data="data">
  <button mat-button (click)="handleChartExportClick(data)">
    <mat-icon>download</mat-icon>
    <span>{{ "pages.landing.buttons.export" | translate }}</span>
  </button>
</ng-template>
